import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined'
import InProgressPageStyle from './useStyles'

export const InProgressPage = () => {
  const classes = InProgressPageStyle()

  return (
    <Box className={classes.boxStyle}>
      <Grid container className={classes.container}>
        <Grid md={12} item className={classes.grid}>
          <BuildCircleOutlinedIcon className={classes.icon} />
        </Grid>
        <Grid md={12} item className={classes.grid}>
          <Typography className={classes.typography}>
            La secci&oacute;n se encuentra en desarrollo
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}
